.root {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  width: 100%;
}

.dropped {
  list-style: none;
  margin: 0;
  padding: var(--tuna-spacing-1);
  border: 1px solid var(--tuna-border-subtle);
  border-radius: var(--tuna-shape-borderRadius);
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}

.droppedItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--tuna-spacing-2);
  font-size: var(--tuna-typography-body2-fontSize);
}

.droppedHeading {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}

.diagnosis {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  padding: var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-subtle);
  border-radius: var(--tuna-shape-borderRadius);
}

.measurements {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
  font-variant-numeric: tabular-nums;
}

.actions {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
}
